var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar__wrapper"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"load-state"}),_vm._v(" "),_c('div',{staticClass:"progress-bar",class:`progress-bar-` + _vm.progress})])
}
var staticRenderFns = []

export { render, staticRenderFns }